'use client';

import { type SliceCreator, type EditorStore, type EditorIndicatorSlice } from './type';

export const createEditorIndicatorSlice: SliceCreator<
    EditorIndicatorSlice,
    EditorStore
> = () => ({
    isGridResizing: false,
    isCellResizing: false,
    isExternalDragging: false,
    isExternalDraggingSection: false,
    draggingType: null,
    draggingElementId: null,
});
